export class OktaConstant {
  static readonly IdToken = 'id_token';
  static readonly AccessToken = 'access_token';
  static readonly TokenType = 'Bearer';
  static readonly DrEnvironment = 'dr';
  static readonly LoggedInHours = 6;

  static readonly Messages = {
    VerifyAuthentication: 'Verifying authentication',
    TokenValidationFailed: 'An error has occurred while validating token.',
  };
}
